import { render, staticRenderFns } from "./AppStatus.vue?vue&type=template&id=0bf2472e"
import script from "./AppStatus.vue?vue&type=script&lang=js"
export * from "./AppStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports